export enum EDeletedStatus {
  Deleted = 'DELETED',
}
